// extracted by mini-css-extract-plugin
export var completionBody = "_lh-2";
export var completionCard = "_lh-0";
export var completionFooter = "_lh-3";
export var completionTitle = "_lh-1";